/**
 * Composite a watermark onto a canvas and downscale to maxDimension.
 * Returns a NEW HTMLCanvasElement; the input canvas is not mutated.
 *
 * Used by the download flow when DOWNLOAD_MODE=watermark on the backend.
 * In quota mode the gate returns applyWatermark=false and this helper
 * is skipped entirely — preserving the architecture for either mode.
 */
export async function applyWatermark(sourceCanvas, { maxDimension } = {}) {
  const w = sourceCanvas.width;
  const h = sourceCanvas.height;
  const longest = Math.max(w, h);
  const scale = maxDimension && longest > maxDimension ? maxDimension / longest : 1;
  const targetW = Math.max(1, Math.round(w * scale));
  const targetH = Math.max(1, Math.round(h * scale));

  const out = document.createElement('canvas');
  out.width = targetW;
  out.height = targetH;
  const ctx = out.getContext('2d');
  ctx.drawImage(sourceCanvas, 0, 0, targetW, targetH);

  const watermark = await loadImage('/watermark.png');
  if (watermark) {
    const wmW = Math.min(watermark.width, targetW * 0.25);
    const wmH = wmW * (watermark.height / watermark.width);
    ctx.globalAlpha = 0.85;
    ctx.drawImage(
      watermark,
      targetW - wmW - 12,
      targetH - wmH - 12,
      wmW,
      wmH,
    );
    ctx.globalAlpha = 1;
  }
  return out;
}

function loadImage(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);    // watermark missing — proceed without
    img.src = src;
  });
}
